export class Paginacao {
  paginaAtual: number = 1;
  totalDeItens: number = 0;
  tamanhoMaximo: number = 5;
  itensPorPagina: number = 10;

  constructor(
    paginaAtual: number = 1,
    totalDeItens: number = 0,
    tamanhoMaximo: number = 5,
    itensPorPagina: number = 10
  ) {
    this.paginaAtual = paginaAtual;
    this.totalDeItens = totalDeItens;
    this.tamanhoMaximo = tamanhoMaximo;
    this.itensPorPagina = itensPorPagina;
  }
}